/**
 * Uuid function.
 * If browser has crypto module return crypto based function.
 * Else return Math.random based function.
 */

// more reliable, better than Math.random based
function uuidv4BasedOnCryptoModule() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
}

// for browser without crypto module
function uuidv4BasedOnRandom() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

const uuid =
  typeof window !== "undefined" &&
  window.crypto &&
  window.crypto.getRandomValues
    ? uuidv4BasedOnCryptoModule
    : uuidv4BasedOnRandom;

export default uuid;
